import React from "react";
import {
    faExclamationTriangle,
    faFileArchive,
    faImage,
    faStickyNote,
    faTrash,
    faUserClock,
    faCheck,
    faDrumstickBite,
} from "@fortawesome/free-solid-svg-icons";

import DuplicateProduct from "../components/duplicateProduct";
import NoteButton from "../../../notes/note-button";

import { WithIcon } from "../../../../shared/table-helpers";
import { ProductImageList } from "../components/imageDisplay";
import { DeleteProduct } from "../components/deleteProduct";

export const columns = (shipmentKey, isDigitalShipment, client, isFoodService, deleteUpc, disableDelete, disableNoteAdd) => {
    const digitalColumn = isDigitalShipment
        ? [
              {
                  Header: WithIcon("Digital Content", faFileArchive),
                  accessor: "hasDigitalContent",
                  Cell: (row) => {
                      return row.value ? WithIcon("Digital Content", faFileArchive) : "";
                  },
                  width: 40,
                  style: { textAlign: "center" },
              },
          ]
        : [];

    return [
        {
            Header: "UPC-Modifier",
            accessor: "upc",
            Cell: (row) => {
                const cssClass = !row.original.isUpcValid ? "txt-error-light" : "";
                const title = !row.original.isUpcValid ? "Improper Upc" : "";
                const text = row.original.modifier ? `${row.value}-${row.original.modifier}` : row.value;

                return (
                    <span className={cssClass} title={title}>
                        {text}
                    </span>
                );
            },
        },
        {
            Header: "Bin",
            accessor: "binTrackingNumber",
        },
        {
            Header: "Package Level",
            accessor: "packageLevel",
            Cell: (row) => {
                return row.value && row.value.text ? row.value.text : "";
            },
            sortMethod: (a, b) => {
                if (!a || !a.sortOrder) {
                    return -1;
                }

                if (a.sortOrder === b.sortOrder) {
                    return 0;
                }

                return a.sortOrder > b.sortOrder ? 1 : -1;
            },
        },
        ...digitalColumn,
        {
            Header: WithIcon("Foodservice", faDrumstickBite),
            accessor: "isFoodService",
            Cell: (row) => {
                return row.value ? WithIcon("Foodservice", faCheck) : "";
            },
            width: 40,
            style: { textAlign: "center" },
        },
        {
            Header: WithIcon("Damaged", faExclamationTriangle),
            accessor: "isDamaged",
            Cell: (row) => {
                return row.value ? (
                    <div>
                        {WithIcon("Damaged", faExclamationTriangle)} <ProductImageList shipmentKey={shipmentKey} product={row.original} />
                    </div>
                ) : (
                    ""
                );
            },
            width: 40,
            style: { textAlign: "center" },
        },
        {
            Header: WithIcon("ClientApproval", faUserClock),
            accessor: "imagesNeedClientApproval",
            Cell: (row) => {
                return row.value ? WithIcon("ClientApproval", faUserClock) : "";
            },
            width: 40,
            style: { textAlign: "center" },
        },
        {
            Header: WithIcon("Premium Editing", faImage),
            accessor: "hasPremiumEditing",
            Cell: (row) => {
                return row.value ? WithIcon("Premium Editing", faImage) : "";
            },
            width: 40,
            style: { textAlign: "center" },
        },
        {
            Header: WithIcon("Delete", faTrash),
            Cell: (row) => {
                return (
                    <div className="button-group">
                        <DeleteProduct
                            shipmentKey={shipmentKey}
                            productKey={row.original.key}
                            disabled={disableDelete}
                            deleteUpc={() => {
                                deleteUpc(row.original.key);
                            }}
                        />
                        {row.original.duplicateProducts && row.original.duplicateProducts.length > 0 && (
                            <DuplicateProduct productKey={row.original.key} duplicateProducts={row.original.duplicateProducts} />
                        )}
                    </div>
                );
            },
            width: 40,
            style: { textAlign: "center" },
        },
        {
            Header: WithIcon("Notes", faStickyNote),
            accessor: "note",
            sortable: false,
            Cell: (row) => {
                const fullUpc = row.original.modifier ? `${row.original.upc}-${row.original.modifier}` : row.original.upc;

                return (
                    <NoteButton
                        upc={fullUpc}
                        shipmentKey={shipmentKey}
                        binTrackingNumber={[row.original.binTrackingNumber]}
                        shipmentProductKey={row.original.key}
                        cxHClientCode={client}
                        noteType="Product"
                        hasNotes={row.original.hasComments}
                        showAll={true}
                        sourcePage="shipment"
                        isReadOnly={disableNoteAdd}
                    />
                );
            },
            filterable: false,
            width: 40,
        },
    ];
};

export const EVENT_VIEW_UPC_IMAGE = "SHOW_UPC_IMAGE";

export const DEFAULT_FORM_DATA = {
    binTrackingNumber: "", // why was it commented?
    barcodeType: {},
    childProductKeys: [],
    currentFileName: "",
    cvid: "",
    damageImage: null,
    generateUpc: false,
    hasDigitalContent: false,
    hasPremiumEditing: false,
    imagesNeedClientApproval: false,
    shipmentProductInternalIdExtras: [],
    isDamaged: false,
    isSample: false,
    key: "",
    modalImage: "",
    modifier: "",
    notes: "",
    packageLevel: null,
    parentProductKeys: [],
    upc: "",

    //isSubmitting: false,
    //isParentChild: false,
    //parentLabel: null,
    //childOf: null,
    //isEdit: false,
};
